export default __webpack_public_path__ + "static/media/e-filing-picturemark-l.fb0b58c7.svg";